import { render, staticRenderFns } from "./oldManFileSecond.vue?vue&type=template&id=4e3c413b&scoped=true&"
import script from "./oldManFileSecond.vue?vue&type=script&lang=js&"
export * from "./oldManFileSecond.vue?vue&type=script&lang=js&"
import style0 from "./oldManFileSecond.vue?vue&type=style&index=0&id=4e3c413b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3c413b",
  null
  
)

export default component.exports